module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #router":{"hooks.onStartExecute":[{"value":function() {
var siteState = fox.getEnv('siteProps.stateAlias');
var member = fox.site.wom1('.PermissionManager').getMemberInfo();
var previewMode = require('../../utils/is-preview-mode.js')();
if (fox.getEnv('site.isBlockedByAvs')) {
siteState = 'closed'
}
if (!previewMode) {
var avsSplash = fox.site.embedWidget('avsSplash', 'Avs_MC');
if (!avsSplash.isRun()) {
avsSplash.run();
} else {
avsSplash.showAvsPopup();
}
}
if (siteState && !previewMode) {
if (!fox.isEmpty(member)) {
return true;
}
switch(siteState) {
case 'closed':
if (fox.isEmpty(member) && this._passedRoute.path != 'site-closed') {
if (this._passedRoute.path.match('password-recovery')) {
return true;
} else {
fox.Router.navigate('site-closed');
return false;
}
}
break;
case 'underConstruction':
if (this._passedRoute.path != 'site-under-construction') {
fox.Router.navigate('site-under-construction');
return false;
}
break;
}
}
if (!fox.isSet(fox.site.showSplash)) {
fox.site.showSplash = window.parseInt(fox.getEnv('siteProps.splashEnabled'))
&& !fox.site.member
&& !fox.cookie.get('splash');
}
if (fox.site.showSplash && previewMode) {
fox.cookie.set('splash', 'off');
fox.site.showSplash = false;
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101050},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/routeToSpecPages.js
// module id = 706
// module chunks = 4